import { atom } from 'recoil'
import { getConfig, getMemberId, getPartnerId, preCheckTokenValidation } from 'core/singleton'
import UserAPI from 'core/axios/userApi/user.api'
import { ConfirmType } from './types'
import { ALARM_ATOM_KEYS } from './keys'
import { AccessTokenData } from '@types'

export const CONFIRM_ALARM = atom<ConfirmType[]>({
  key: ALARM_ATOM_KEYS.CONFIRM_ALARM_LIST,
  default: [],
  effects: [
    ({ setSelf }) => {
      const config = getConfig()
      if (!config?.alarm?.use) return
      const loadConfirmData = async () => {
        await new Promise((resolve) => {
          let count = 0
          const check = () => {
            const memberId = getMemberId()
            if (memberId) {
              resolve(memberId)
            } else if (count >= 5) {
              resolve(null)
            } else {
              count++
              setTimeout(check, 100)
            }
          }
          check()
        })
        const memberId = getMemberId()
        const partnerId = getPartnerId()
        const localToken = localStorage.getItem(
          partnerId ? `sauce_collect_accessToken_${partnerId}` : 'sauce_collect_accessToken',
        )
        const parsedTokenData: AccessTokenData = localToken && JSON.parse(localToken)

        if (!memberId) return

        const parsedMemberId = (parsedTokenData && parsedTokenData?.memberId) ?? ''

        if (config?.guestLogin.use && !parsedMemberId) return

        const alarmInfo = await UserAPI.getAlarmInfo({
          memberId: config?.guestLogin.use ? parsedMemberId : memberId,
        })
        const list = alarmInfo?.data?.alarms?.map(
          ({ broadcastUniqueId }: { broadcastUniqueId: string }) => {
            return { broadcastId: broadcastUniqueId }
          },
        )
        const parsedTokenDate = parsedTokenData
          ? parsedTokenData?.date
            ? parsedTokenData?.date
            : new Date()
          : new Date()
        const isCheckTokenValidation = preCheckTokenValidation(parsedTokenDate)
        if (isCheckTokenValidation && list.length === 0) {
          localStorage.removeItem(
            partnerId ? `sauce_collect_accessToken_${partnerId}` : 'sauce_collect_accessToken',
          )
        }
        if (list != null) {
          setSelf(list)
        }
      }
      loadConfirmData()
    },
  ],
})
